import { cloneDeepWith } from 'lodash-es';
export const CLONE_METHOD_NAME = Symbol('clone');
/**
 * Copy of cloneDeep from lodash-es, but with addition of custom cloning
 * behavior defined by the [CLONE_METHOD_NAME] method on the object
 */
export function cloneDeep(value) {
    return cloneDeepWith(value, cloneCustomizer);
}
function isClonable(value) {
    return (typeof value === 'object' &&
        value != null &&
        CLONE_METHOD_NAME in value &&
        typeof value[CLONE_METHOD_NAME] === 'function');
}
// Function that is meant to be passed to cloneDeepWith from lodash-es
// It uses custom cloning behavior defined by the [CLONE_METHOD_NAME] method on the object
function cloneCustomizer(value) {
    if (isClonable(value)) {
        return value[CLONE_METHOD_NAME]();
    }
    // Fallback to default cloning behavior
    return undefined;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvbmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL3V0aWxzL2Nsb25lLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxhQUFhLEVBQUUsTUFBTSxXQUFXLENBQUE7QUFFekMsTUFBTSxDQUFDLE1BQU0saUJBQWlCLEdBQUcsTUFBTSxDQUFDLE9BQU8sQ0FBQyxDQUFBO0FBTWhEOzs7R0FHRztBQUNILE1BQU0sVUFBVSxTQUFTLENBQUksS0FBUTtJQUNuQyxPQUFPLGFBQWEsQ0FBQyxLQUFLLEVBQUUsZUFBZSxDQUFDLENBQUE7QUFDOUMsQ0FBQztBQUVELFNBQVMsVUFBVSxDQUNqQixLQUFjO0lBRWQsT0FBTyxDQUNMLE9BQU8sS0FBSyxLQUFLLFFBQVE7UUFDekIsS0FBSyxJQUFJLElBQUk7UUFDYixpQkFBaUIsSUFBSSxLQUFLO1FBQzFCLE9BQU8sS0FBSyxDQUFDLGlCQUFpQixDQUFDLEtBQUssVUFBVSxDQUMvQyxDQUFBO0FBQ0gsQ0FBQztBQUVELHNFQUFzRTtBQUN0RSwwRkFBMEY7QUFDMUYsU0FBUyxlQUFlLENBQUMsS0FBYztJQUNyQyxJQUFJLFVBQVUsQ0FBQyxLQUFLLENBQUMsRUFBRSxDQUFDO1FBQ3RCLE9BQU8sS0FBSyxDQUFDLGlCQUFpQixDQUFDLEVBQUUsQ0FBQTtJQUNuQyxDQUFDO0lBRUQsdUNBQXVDO0lBQ3ZDLE9BQU8sU0FBUyxDQUFBO0FBQ2xCLENBQUMifQ==